/**
 * This class "PageComponent" is an abstraction of "PageHooks"
 * for page component contruction / destruction.
 * 
 * =============================================================
 * 
 * new PageComponent(
 *     ".my-component-selector",
 *     class MyComponentClass {
 *         construct({ container, node }) {}
 *         destroy() {}
 *     }
 * }
 * 
 */

import { PageHooks } from "barba"

class PageComponent {

    constructor(s, c) {
        this.selector = s
        this.class = c
        this.record = []

        const afterLeave = this.afterLeave.bind(this)
        const beforeEnter = this.beforeEnter.bind(this)

        new class extends PageHooks {
            afterLeave(data) {
                afterLeave(data)
            }
            beforeEnter(data) {
                beforeEnter(data)
            }
        }
    }

    afterLeave({ current }) {
        for (let i = this.record.length - 1; i >= 0; i--) {
            if (current.container.contains(this.record[i].__node__)) {
                if (this.record[i].destroy && typeof this.record[i].destroy === 'function') {
                    this.record[i].destroy()
                } else {
                    console.warn("Class is missing a 'destroy()' method.", this.record[i])
                }
                this.record[i] = null
                this.record.splice(i, 1)
            }
        }
    }

    beforeEnter({ next }) {
        for (let node of next.container.querySelectorAll(this.selector)) {
            let classInstance = new this.class({ container: next.container, node })
            classInstance.__node__ = node
            this.record.push(classInstance)
        }
    }

}

export { PageComponent }
export default PageComponent